import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { EvaArrowIosBackFill } from './icons/BackButton'

export default function AddCampaign() {
  let navigate = useNavigate()

  const [campaignTitle, setCampaignTitle] = useState('')
  const [campaignRoute, setCampaignRoute] = useState('')
  const [campaignDescription, setCampaignDescription] = useState('')
  const [errors, setErrors] = useState({ title: '', route: '', description: '' })

  const handleNextClick = () => {
    let validationErrors = { title: '', route: '', description: '' }
    if (campaignTitle === '') validationErrors.title = 'Campaign title is required.'
    if (campaignRoute === '') validationErrors.route = 'Campaign route is required.'
    if (campaignDescription === '') validationErrors.description = 'Campaign description is required.'

    setErrors(validationErrors)

    const isValid = !Object.values(validationErrors).some(error => error !== '')

    if (isValid) {
      const campaignData = {
        title: campaignTitle,
        route: campaignRoute,
        description: campaignDescription
      }
      navigate('/campaign/select-recipients', { state: { campaignData } })
    }
  }

  const handleTitleChange = (e) => {
    setCampaignTitle(e.target.value)
    if (e.target.value !== '') setErrors(prevErrors => ({ ...prevErrors, title: '' }))
  }

  const handleRouteChange = (e) => {
    setCampaignRoute(e.target.value)
    if (e.target.value !== '') setErrors(prevErrors => ({ ...prevErrors, route: '' }))
  }

  const handleDescriptionChange = (e) => {
    setCampaignDescription(e.target.value)
    if (e.target.value !== '') setErrors(prevErrors => ({ ...prevErrors, description: '' }))
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          cursor: 'pointer',
          alignContent: 'center',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
        onClick={() => navigate(-1)}
      >
        <div style={{ padding: 5, backgroundColor: 'white', borderRadius: 100, marginRight: 5 }}>
          <EvaArrowIosBackFill />
        </div>
        <p style={{ fontSize: 14, fontWeight: 'bold', margin: 0 }}>Back</p>
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', paddingRight: 30, paddingLeft: 50, marginTop: 20 }}>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <p
            style={{
              backgroundColor: '#2ABD84',
              borderRadius: 50,
              paddingRight: 10,
              paddingLeft: 10,
              paddingTop: 5,
              paddingBottom: 5,
              color: 'white',
              fontWeight: 'bold',
            }}
          >
            1
          </p>
          <p style={{ fontSize: 14, marginLeft: 5, color: '#2ABD84' }}>Create Campaign</p>
        </div>

        <hr style={{ width: 170, marginLeft: 5, marginRight: 5, color: '#2ABD84' }} />
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <p
            style={{
              backgroundColor: '#B0B0B0',
              borderRadius: 50,
              paddingRight: 10,
              paddingLeft: 10,
              paddingTop: 5,
              paddingBottom: 5,
              color: 'white',
              fontWeight: 'bold',
            }}
          >
            2
          </p>
          <p style={{ fontSize: 14, marginLeft: 5 }}>Select Recipients</p>
        </div>

        <hr style={{ width: 170, marginLeft: 5, marginRight: 5 }} />
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <p
            style={{
              backgroundColor: '#B0B0B0',
              borderRadius: 50,
              paddingRight: 10,
              paddingLeft: 10,
              paddingTop: 5,
              paddingBottom: 5,
              color: 'white',
              fontWeight: 'bold',
            }}
          >
            3
          </p>
          <p style={{ fontSize: 14, marginLeft: 5 }}>campaign periods</p>
        </div>

        <hr style={{ width: 170, marginLeft: 5, marginRight: 5 }} />
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <p
            style={{
              backgroundColor: '#B0B0B0',
              borderRadius: 50,
              paddingRight: 10,
              paddingLeft: 10,
              paddingTop: 5,
              paddingBottom: 5,
              color: 'white',
              fontWeight: 'bold',
            }}
          >
            4
          </p>
          <p style={{ fontSize: 14, marginLeft: 5 }}>Confirm</p>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          flexDirection: 'row',
          marginRight: 30,
          marginLeft: 30,
          marginTop: 10,
          backgroundColor: 'white',
          paddingRight: 30,
          paddingLeft: 30,
          paddingTop: 60,
          paddingBottom: 60,
          borderRadius: 10,
        }}
      >
        <div className='col-lg-6 col-12 mb-10'>
          <div style={{ padding: 15 }}>
            <h2 style={{ fontSize: 36, color: '#736F6F', textAlign: 'justify', marginBottom: 20 }}>
              Create Campaign
            </h2>
            <p style={{ fontSize: 16, color: '#898484' }}>
              Campaigns are used to setup broadcast to reach existing contacts, Leads and company...
            </p>
            <p style={{ fontSize: 16, color: '#898484', textAlign: 'justify' }}>
              You can begin by giving your campaign a brief{' '}
              <strong>Title, Choose Your campaign Route</strong> This can be via{' '}
              <strong>Email, SMS or Whats-app.</strong>
            </p>
            <p style={{ fontSize: 16, color: '#898484', textAlign: 'justify' }}>
              <strong>Description</strong> explain the purpose for your campaign, it can also be a
              in a list form or how ever you choose.
            </p>
          </div>
        </div>
        <div className='col-lg-6 col-12'>
          <form>
            <div className='form-group mb-3'>
              <label style={{ color: '#4A4747', fontSize: 16 }}>Type campaign Title</label>
              <input
                type='text'
                className='form-control'
                placeholder='Title of Campaign'
                value={campaignTitle}
                onChange={handleTitleChange}
              />
              {errors.title && <p className='text-danger'>{errors.title}</p>}
            </div>

            <div className='form-group mb-3'>
              <label style={{ color: '#4A4747', fontSize: 16 }}>Choose Campaign route</label>
              <select
                className='form-control form-select'
                value={campaignRoute}
                onChange={handleRouteChange}
              >
                <option value={''} disabled>
                  Select Campaign route
                </option>
                {[
                  { name: 'Email', route: 1 },
                  { name: 'SMS', route: 2 },
                ]?.map((e, index) => (
                  <option value={e?.route} key={index}>
                    {e?.name}
                  </option>
                ))}
              </select>
              {errors.route && <p className='text-danger'>{errors.route}</p>}
            </div>
            <div className='form-group mb-3'>
              <label style={{ color: '#4A4747', fontSize: 16 }}>Description</label>
              <textarea
                required
                type='text'
                style={{ height: 150 }}
                className='form-control'
                placeholder='Campaign Description'
                value={campaignDescription}
                onChange={handleDescriptionChange}
              />
              {errors.description && <p className='text-danger'>{errors.description}</p>}
            </div>

            <div className='d-flex justify-content-end mt-3'>
              <button
                type='button'
                className='btn'
                style={{
                  padding: '10px 70px',
                  borderRadius: 20,
                  backgroundColor: '#00B649',
                  color: 'white',
                  marginTop: 10,
                }}
                onClick={handleNextClick}
              >
                Next
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}
